import { useGoalById } from 'features/goals';
import { useUpdateUserSettings } from 'features/user/hooks/use-update-user-settings';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Plus, SettingsSort18 } from 'shared/assets/icons';
import { IconButton } from 'shared/components/ui/icon-button';
import { PageSectionBase } from 'shared/components/ui/page-section-base';
import {
  PopupMenu,
  PopupMenuList,
  PopupMenuListItem,
  PopupMenuToggle,
} from 'shared/components/ui/popup-menu';
import { useOpenCreateGoalDialog } from 'shared/contexts/goal-form';
import { useUser } from 'shared/hooks/use-user';

import { SubgoalsOverview } from './components/subgoals-overview';
import * as Styled from './goal-detail.style';

export const Roadmap: React.FC = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const goal = useGoalById(id);
  const user = useUser();
  const updateUserSettings = useUpdateUserSettings();
  const interactionsRef = useRef<HTMLDivElement>(null);
  const [isSortMenuOpen, setIsSortMenuOpen] = useState(false);

  const openCreateGoalDialog = useOpenCreateGoalDialog();

  const showCompletedGoals =
    user?.settings?.goalDetail?.roadmap?.showCompletedGoals ?? true;

  const onShowCompletedGoals = (value: boolean) => {
    updateUserSettings({
      goalDetail: {
        roadmap: {
          showCompletedGoals: value,
        },
      },
    });
  };

  const onAddGoal = () => {
    if (!goal) {
      return;
    }
    openCreateGoalDialog({ parentIds: [goal.id] });
  };

  if (!goal) {
    return null;
  }

  return (
    <PageSectionBase
      title={t('pages.goal-detail.tabs.roadmap.label')}
      fullSize
      noPadding
      interactions={
        <Styled.InteractionsContainer ref={interactionsRef}>
          <IconButton
            icon={SettingsSort18}
            onClick={() => setIsSortMenuOpen(true)}
          />
          <IconButton icon={Plus} onClick={onAddGoal} />
          {isSortMenuOpen && (
            <PopupMenu
              referenceElement={interactionsRef}
              onOutside={() => setIsSortMenuOpen(false)}
              position="bottom-end"
            >
              <PopupMenuList>
                <PopupMenuListItem>
                  <PopupMenuToggle
                    label={t('general.labels.goals.show-completed-goals')}
                    checked={showCompletedGoals}
                    onChange={onShowCompletedGoals}
                  />
                </PopupMenuListItem>
              </PopupMenuList>
            </PopupMenu>
          )}
        </Styled.InteractionsContainer>
      }
    >
      <SubgoalsOverview
        goal={goal}
        hideCompleted={!showCompletedGoals}
        fullSize
      />
    </PageSectionBase>
  );
};
